// src/pages/admin/Dashboard.jsx
import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { logAPI } from '../../services/api';
import { Pill, Calculator, Users, Layers, Loader2 } from 'lucide-react';

const StatCard = ({ label, value, icon, color }) => (
  <div className="card" style={{ padding: 24 }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div>
        <div style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--gray-400)', marginBottom: 6 }}>
          {label}
        </div>
        <div style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--gray-900)', lineHeight: 1 }}>{value ?? '—'}</div>
      </div>
      <div style={{ width: 48, height: 48, borderRadius: 12, background: color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: color }}>
        {icon}
      </div>
    </div>
  </div>
);

const Dashboard = () => {
  const [stats, setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    logAPI.getDashboard()
      .then(r => setStats(r.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Dashboard">
      <div className="page-header">
        <div>
          <h2 className="page-title">Dashboard</h2>
          <p className="page-subtitle">Welcome back — here's what's happening</p>
        </div>
      </div>

      {loading ? (
        <div className="flex-center" style={{ padding: 64 }}><Loader2 className="spinner" size={32} /></div>
      ) : (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16, marginBottom: 28 }}>
            <StatCard label="Total Medicines"     value={stats?.totalMedicines}     icon={<Pill size={24} />} color="#1a6ef5" />
            <StatCard label="Dose Calculations"   value={stats?.totalCalculations}  icon={<Calculator size={24} />} color="#12b76a" />
            <StatCard label="Active Users"        value={stats?.totalUsers}         icon={<Users size={24} />} color="#f79009" />
            <StatCard label="Categories"          value={stats?.totalCategories}    icon={<Layers size={24} />}  color="#7c3aed" />
          </div>

          <div className="card">
            <div className="card-header">
              <h3 style={{ margin: 0, fontSize: '1rem' }}>Recent Calculations</h3>
            </div>
            {stats?.recentLogs?.length ? (
              <div className="table-container" style={{ border: 'none', borderRadius: 0 }}>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Medicine</th>
                      <th>Calculated Dose</th>
                      <th>Date & Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.recentLogs.map((log, i) => (
                      <tr key={i}>
                        <td><strong>{log.medicine_name}</strong></td>
                        <td style={{ fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{log.calculated_dose} {log.unit}</td>
                        <td style={{ color: 'var(--gray-400)', fontSize: '0.8125rem' }}>
                          {new Date(log.created_on).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="empty-state">
                <div className="empty-state-icon"><Calculator size={40} /></div>
                <p>No calculations yet</p>
              </div>
            )}
          </div>
        </>
      )}
    </AdminLayout>
  );
};

export default Dashboard;
